import data from "@/assets/data/GamerData.js";

import Mutations from "@/store/modules/gamerData/mutations.js";
import Getters from "@/store/modules/gamerData/getters.js";

export default {
  state() {
    return {
      selectedGamer: 0,
      allGamerData: data.gamerData,
      selectedGamerData: [],
      gamerRate: 1.2,
      mySalary:0,
    };
  },
  mutations: Mutations,
  getters: Getters,
};
